const BUTTON_AUTH = ['08000113', '08000114'];
export default {
    configuration: true,
    'buttonList': [
        {
            'type': 'text',
            'icon': 'el-icon-check',
            'label': '保存',
            'size': 'small',
            'event': 'save',
            'ifHas': BUTTON_AUTH[0]
        },
        {
            'type': 'text',
            'icon': 'el-icon-refresh',
            'label': '同步',
            'size': 'small',
            'event': 'synchronize',
            'loading': false,
            'ifHas': BUTTON_AUTH[1]
        },
        {
            'type': 'text',
            'icon': 'el-icon-circle-plus-outline',
            'label': '新增',
            'size': 'small',
            'event': 'add',
        },
        {
            'type': 'text',
            'icon': 'el-icon-delete',
            'label': '删除',
            'size': 'small',
            'event': 'del',
        },
    ],
    'table': {
        'switchType': true,
        'tableCut': true,
        'clickModify': true,
        'clickState': true,
        'selectBtn': true,
        'height': 'calc(100vh - 215px)',
        'columns': [
            {
                'label': '股东姓名',
                'prop': 'shareholderName',
                'width': '120px'
            },
            {
                'type': 'text',
                'label': '身份证',
                'prop': 'idCard',
                'require': true,
                'width': '180px'
            },
            {
                'label': '持股比例',
                'prop': 'shareholdingRatio',
                'width': '150px'
            },
            {
                'label': '关联公司',
                'prop': 'relateCompanyName',
                'width': '150px'
            },
            {
                'label': '生成时间',
                'prop': 'createTime',
                'width': '150px'
            },
            {
                'label': '更改时间',
                'prop': 'updateTime',
                'width': '150px'
            }
        ],
        'action': [],
        'leftOperation': false,
        'leftWidth': 250
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};